export default [
  {
    path: '/cart',
    name: 'cart.list',
    meta: {
      authRequired: true
    },
    component: () => import('@/router/views/cart/cart-item-list')
  }
]
